import React from "react";
import { Table, Label } from "semantic-ui-react";
import { Link } from "react-router-dom";
import {
  shortenMonth,
  replaceTextFunction,
  // StyledMeta,
} from "../helpers/TableUtils.jsx";
import { hasResults } from "../helpers/EventUtils";
import { RESULTS_DETAILS_LINK } from "../helpers/AppConsts";

const TableRow = ({ bridgeEvent }) => {
  const labelRender = ({ event_day, event_month, event_year }) => {
    return (
      <Label style={{ fontSize: 14, color: "#008000" }}>
        {event_day}-{shortenMonth(event_month)}-{event_year}
      </Label>
    );
  };

  // const nameRender = ({ event_name }) => {
  //   return <StyledMeta>{event_name}</StyledMeta>;
  // };

  const renderLink = (renderer, bridgeEvent) => {
    return (
      <Link
        to={`${RESULTS_DETAILS_LINK}/${replaceTextFunction(
          bridgeEvent.event_results)}/${bridgeEvent.event_id}/${bridgeEvent.event_date}`}
      >
        {renderer(bridgeEvent)}
      </Link>
    );
  };

  const renderTable = () => {
    return (
      <React.Fragment>
        <Table.Row style={{ fontSize: 16 }}>
          <Table.Cell>{renderLink(labelRender, bridgeEvent)}</Table.Cell>
          {/*<Table.Cell>{renderLink(nameRender, bridgeEvent)}</Table.Cell>*/}
          <Table.Cell>{bridgeEvent.event_location}</Table.Cell>
          <Table.Cell>{bridgeEvent.event_club}</Table.Cell>
          <Table.Cell>
            {bridgeEvent.event_results !== "available after competition" && (
            <a
              href={bridgeEvent.event_results}
              target="_blank"
              rel="noopener noreferrer"
            >
              Detailed Results
            </a>
            )}
          </Table.Cell>
          <Table.Cell>

            {bridgeEvent.event_hands !== "available after competition" && (
                <a
                    href={bridgeEvent.event_hands}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Hands
                </a>
            )}



          </Table.Cell>
        </Table.Row>
      </React.Fragment>
    );
  };

  return hasResults(bridgeEvent) ? renderTable() : <React.Fragment />;
};

export default TableRow;
